import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild,EventEmitter, Input, Output } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl, ValidatorFn, ValidationErrors, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { interval, switchMap, takeWhile, Observable, throwError } from 'rxjs';
import { map, startWith, catchError, tap } from 'rxjs/operators';
import { openDB } from 'idb';
import { v4 as uuidv4 } from 'uuid';
import { environment } from "src/environments/environment";
import { RegistroCandidatoRequestInterface } from '../../../../core/interfaces/candidato/registro-candidato-request.interface';
import { CandidatoDatosPersonalesInterface } from '../../../../core/interfaces/candidato/candidato-datos-personales.interface';
import { CandidatoMediosContactoInterface } from '../../../../core/interfaces/candidato/candidato-medios-contacto.interface';
import { CandidatoPretensionesInterface } from '../../../../core/interfaces/candidato/candidato-pretensiones.interface';
import { CandidatoCVInterface } from '../../../../core/interfaces/candidato/candidato-cv.interface';
import { CandidatoDomicilioInterface } from '../../../../core/interfaces/candidato/candidato-domicilio.interface';
import { EstatusResponse } from '../../../../core/interfaces/meta-defender/meta-defender-response.interface';
import { IntTelInputInterface } from '../../../../core/interfaces/elementos/int-tel-input.interface';
import { NavbarService } from 'src/app/modules/navbar/navbar.service';
import { Empresa } from 'src/app/core/Interfaces/vacantes/empresa.interface';
import { VacanteResumen } from 'src/app/core/Interfaces/vacantes/vacante-resumen.interface';
import { AuthApiService } from 'src/app/core/services/auth-api-service';
import { SearchJobApiService } from 'src/app/core/services/search-job-api.service';
import { EncryptionService } from 'src/app/core/services/encryption.service';

import { CandidatosApiService } from 'src/app/core/services/candidatos-api.service';
import { EscaneoApiService } from '../../../../core/services/escaneo-api.service';
import { CatalogosApiService } from '../../../../core/services/catalogos-api.service';

import { IndexedDbService } from '../../../../core/services/indexed-db.service';
import { phone10DigitsValidator } from 'src/app/shared/validators/telephone.validator';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-registro-corto',
  templateUrl: './registro-corto.component.html',
  styleUrls: ['./registro-corto.component.scss'],
  standalone: false
})
export class RegistroCortoComponent implements OnInit, AfterViewInit {
  @Output() cambioPaso = new EventEmitter<number>();
  @Input() esRegistro: boolean = true;
  @Input() vacante: any = {};

  isLoading = false;
  progresoEscaneo: number = 0;
  dataIdEscaneo: string = '';
  selectedFile: File | null = null;
  fileBase64: string | null = null;

  nombre: string = '';
  cvFileName: string = 'Seleccione un archivo';
  primerApellido: string = '';
  segundoApellido: string = '';
  email: string = '';
  celular: string = '';
  pretensiones: string = '';
  cvNombre: string = '';
  fechaNacimiento: string = '';
  giroEmpleo: string = '';
  experiencia: number = 0;
  positionId: number = 0;
  recaptcha: string | null = '';

  scanResult: any = null;
  isScanning: boolean = false;

  catalogoSueldos: any = [];

  emailSuggestions: string[] = [];
  domains = ['gmail.com', 'outlook.com', 'yahoo.com', 'hotmail.com'];

  selectedJobOpenning: string | null = '';
  isLoggedIn$ = this.authApiService.isLoggedIn();
  isLoggedIn: boolean = false;
  jobOpeningSelected: VacanteResumen | null = null;
  businessInfo: Empresa | null = null;
  pasos = ['Datos Personales', 'Curriculum Vitae', 'Activación'];
  pasoActual = 1;

  candidatoInformacion: RegistroCandidatoRequestInterface = {} as RegistroCandidatoRequestInterface;

  registroForm = new FormGroup({
    nombre: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿÑñ0-9._ -]*$/)]),
    primerApellido: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿÑñ0-9._ -]*$/)]),
    segundoApellido: new FormControl('', [Validators.required, Validators.pattern(/^[a-zA-ZÀ-ÿÑñ0-9._ -]*$/)]),
    email: new FormControl('', [Validators.required, Validators.email]),
    celular: new FormControl(null as any, [Validators.required, phone10DigitsValidator()]),
    fechaNacimiento: new FormControl('', [Validators.required]),
    pretensiones: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
    giroEmpleo: new FormControl('', [Validators.required]),
    experiencia: new FormControl(0, [Validators.required, Validators.min(0)]),
    positionId: new FormControl(0)
  });

  registroFormCV = new FormGroup({
    cv: new FormControl('', [Validators.required, this.validacionArchivos]),
    privacidad: new FormControl(false, [Validators.requiredTrue]),
    recaptcha: new FormControl('', [Validators.required])
  });

  @ViewChild('cv') fileInput!: ElementRef<HTMLInputElement>;
  ngAfterViewInit() {
    // Ahora fileInput está disponible
    console.log('Referencia al input de archivo:', this.fileInput);
    
    // Mover el selector de país al label después de que se renderice
    setTimeout(() => {
      this.movePhoneCountrySelector();
    }, 200);
  }

  movePhoneCountrySelector(): void {
    const phoneInput = document.querySelector('.phone-input-field .iti__flag-container') as HTMLElement;
    const phoneSelector = document.querySelector('.phone-country-selector') as HTMLElement;
    
    if (phoneInput && phoneSelector) {
      // Mover el selector de país al label (no clonar, mover realmente)
      phoneSelector.appendChild(phoneInput);
      
      // Ajustar estilos del selector movido
      phoneInput.style.position = 'relative';
      phoneInput.style.top = '0';
      phoneInput.style.left = '0';
      phoneInput.style.display = 'block';
    }
  }
  constructor(
    private navbarService: NavbarService,
    private renderer: Renderer2,
    private candidatosApiService: CandidatosApiService,
    private escaneoApiService: EscaneoApiService,
    private catalogosApiService: CatalogosApiService,
    private indexedDbService: IndexedDbService,
    // private recaptchaV3Service: ReCaptchaV3Service,
    private router: Router,
    private authApiService: AuthApiService,
    private searchJobApiService: SearchJobApiService, 
    private encryptionService: EncryptionService,
    private fb: FormBuilder,
    private http: HttpClient) 
  {
    this.navbarService.hide();

    this.registroForm.controls['email'].valueChanges.pipe(
      startWith(''),
      map(value => this.generateSuggestions(value || ''))
    ).subscribe(suggestions => this.emailSuggestions = suggestions);

  }


  get getEsRegistro(): boolean {
    return this.esRegistro;
  }

  ngOnInit(): void {
    this.isLoggedIn$.subscribe(value => this.isLoggedIn = value);

    // Inicializar positionId si hay una vacante
    if (this.vacante?.requisicion) {
      this.positionId = Number(this.vacante.requisicion) || 0;
      this.registroForm.get('positionId')?.setValue(this.positionId);
    }

    this.isLoading = true;
    if (this.isLoggedIn) {
      this.registroForm.get('email')?.disable();
      this.pasos = ['Datos Personales', 'Curriculum Vitae', 'Postulación'];

      this.registroForm.get('celular')?.clearValidators();
      this.registroForm.get('celular')?.clearAsyncValidators();
      this.registroForm.get('celular')?.updateValueAndValidity();

      this.registroFormCV.get('privacidad')?.clearValidators();
      this.registroFormCV.get('privacidad')?.clearAsyncValidators();
      this.registroFormCV.get('privacidad')?.updateValueAndValidity();
      
      this.registroFormCV.get('recaptcha')?.clearValidators();
      this.registroFormCV.get('recaptcha')?.clearAsyncValidators();
      this.registroFormCV.get('recaptcha')?.updateValueAndValidity();

      const controlCV = this.registroFormCV.get('cv');
      controlCV?.clearValidators();
      controlCV?.updateValueAndValidity();

      console.log("vacante>>>>", this.vacante);
      if (this.vacante?.requisicion) {
        this.positionId = Number(this.vacante.requisicion) || 0;
        this.registroForm.get('positionId')?.setValue(this.positionId);
      }
    }

    // Solo cargar catálogo de sueldos
    this.catalogosApiService.getSueldos().subscribe(
      (data: any) => {
        let _payload: any = data.payload;
        this.catalogoSueldos = _payload.data;
        this.isLoading = false;
      }, (error: {}) => {
        this.isLoading = false;
        console.error(error);
      }
    );
  }

  private tienePretensiones(): boolean {
    return !!this.candidatoInformacion?.pretensiones?.length;
  }


  generateSuggestions(value: any): string[] {
    const email = String(value || ''); // Asegura que siempre sea un string

    if (!email.includes('@')) {
      return [];
    }

    const [user, domain] = email.split('@');
    return this.domains
      .filter(d => d.startsWith(domain))
      .map(d => `${user}@${d}`);
  }
  onFileSelected() {
    console.log("click")
    this.renderer.selectRootElement(this.fileInput.nativeElement).click();
  }


  onCaptchaResolved(token: string | null): void {
    this.recaptcha = token;

    if (token) {
      this.registroFormCV.get('recaptcha')?.setValue(token);
    } else {
      this.registroFormCV.get('recaptcha')?.reset();
    }
  }

  // ejecutarReCaptcha() {
  //   this.recaptchaV3Service.execute('login').subscribe((token: string) => {
  //     console.log(token)
  //     this.recaptcha = token;
  //   });
  // }
  setEmail(suggestion: string = '') {
    this.registroForm.controls['email'].setValue(suggestion);
    this.emailSuggestions = [];
  }

  mensajePostulacion = '';
  mensajeExito: string = '';
  mensajeError: string = '';

  /**
   * Método que se ejecuta al enviar el formulario
   */
  onSubmit() {
    // Limpiar mensajes anteriores
    this.mensajeExito = '';
    this.mensajeError = '';

    // Validar formulario
    if (this.registroForm.invalid) {
      this.registroForm.markAllAsTouched();
      this.mensajeError = 'Por favor, completa todos los campos obligatorios correctamente.';
      return;
    }

    // Llamar al servicio de registro
    this.isLoading = true;
    this.registrarCandidato().subscribe({
      next: (response) => {
        console.log('✅ Candidato registrado exitosamente en Appian:', response);
        
        // Mostrar mensaje de éxito y resetear formulario
        this.isLoading = false;
        this.mensajeExito = '¡Tu registro se ha completado exitosamente! Nos pondremos en contacto contigo pronto.';
        this.mensajeError = '';
        
        // Resetear formulario después de 3 segundos
        setTimeout(() => {
          this.registroForm.reset();
        }, 3000);
      },
      error: (error) => {
        this.isLoading = false;
        console.error('❌ Error al registrar candidato en Appian:', error);
        this.mensajeError = 'Hubo un error al registrar tu información. Por favor, intenta nuevamente.';
        this.mensajeExito = '';
      }
    });
  }

  async registro() {
    this.isLoading = true;
    this.celular = (this.registroForm.value.celular || '').toString();
    if (this.registroForm.valid) {
      if (this.getEsRegistro && (!this.selectedFile || !this.fileBase64)) return;
      this.isLoading = true;

      let _registroCandidato: RegistroCandidatoRequestInterface = {} as RegistroCandidatoRequestInterface;
      _registroCandidato.datos_personales = {} as CandidatoDatosPersonalesInterface;
      _registroCandidato.medios_contacto = {} as CandidatoMediosContactoInterface;
      _registroCandidato.pretensiones = [] as CandidatoPretensionesInterface[];

      _registroCandidato.domicilio = {} as CandidatoDomicilioInterface;
      _registroCandidato.domicilio.idLocalidad = ''; // No se solicita en registro corto
      _registroCandidato.domicilio.idEntidad = ''; // No se solicita en registro corto
      _registroCandidato.domicilio.pais = "MX";

      // CV
      if (!this.getEsRegistro && (this.selectedFile && this.fileBase64)) {
        _registroCandidato.cv = {} as CandidatoCVInterface;
        _registroCandidato.cv.nombre = this.selectedFile.name;
        _registroCandidato.cv.formato = this.getExtensionArchivo(this.selectedFile.name);
        _registroCandidato.cv.contenido = this.fileBase64.split(',')[1];
      }

      // Pretenciones
      let _candidatoPretensiones = {} as CandidatoPretensionesInterface;
      // _candidatoPretensiones.tipo = "salario";
      // _candidatoPretensiones.valor = this.pretensiones;
      // _candidatoPretensiones.moneda = "MXN";
      // _candidatoPretensiones.periodo = "mensual";
      // _candidatoPretensiones.puesto = this.puestoInteres;
      // _candidatoPretensiones.idArea = "1";

      _candidatoPretensiones.tTrabajo = "P"; // medio tiempo
      _candidatoPretensiones.ubicacion = 1;
      _candidatoPretensiones.valor = this.pretensiones;
      _candidatoPretensiones.puesto = ''; // No se solicita puesto específico en registro corto
      _candidatoPretensiones.ftrabajo = '1';
      _registroCandidato.pretensiones.push(_candidatoPretensiones);

      // Medios de contacto
      let _mediosContacto: CandidatoMediosContactoInterface = {} as CandidatoMediosContactoInterface;
      _mediosContacto.email = this.email;
      _mediosContacto.telefono_movil = this.celular.replace(/\s+/g, '').replace(/\D/g, '');
      _mediosContacto.codigo_area = '52'; // Código de país por defecto para México
       _registroCandidato.medios_contacto = _mediosContacto;
      // _mediosContacto.tipo = 'email';
      // _mediosContacto.valor = this.email;
      // _mediosContacto.codigo_area = '0';
      // _registroCandidato.medios_contacto.push(_mediosContacto);

      // _mediosContacto = {} as CandidatoMediosContactoInterface;
      // _mediosContacto.tipo = 'telefono_movil';
      // _mediosContacto.valor = this.celular.number;
      // _mediosContacto.codigo_area = this.celular.dialCode;
      // _registroCandidato.medios_contacto.push(_mediosContacto);

      // Datos personales
      _registroCandidato.datos_personales.nombre = this.nombre;
      _registroCandidato.datos_personales.apellidosTmp = this.primerApellido + ' ' + this.segundoApellido;
      _registroCandidato.datos_personales.curp = ''; // No se solicita en registro corto
      _registroCandidato.datos_personales.rfc = ''; // No se solicita en registro corto
      _registroCandidato.datos_personales.password = ''; // No se solicita en registro corto
      _registroCandidato.datos_personales.updatePassword = false; // No aplica en registro corto

      // const uuid = uuidv4();
      _registroCandidato.id = '1';

      await this.indexedDbService.guardarUsuario(_registroCandidato);

      // Registro completado
      this.isLoading = false;
    }
  }


  reintentarActivacion() {
    this.recibirMensajeCodigoActivacion('');
    this.recibirCodigoActivacion('');
    this.registro();
  }

  // Función para manejar el cambio de archivo
  onFileChange(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (input.files && input.files[0]) {
      const file = input.files[0];
      this.cvFileName = file.name;
      this.selectedFile = file;
      this.convertirBase64(file);
      // this.registroForm.controls['cv']?.setValue(file);

      // this.isScanning = true;
      // this.escaneoApiService.postEscanearAntivirus(file).subscribe(
      //   (data: []) => {
      //     console.log(data);
      //     let _response: any = data;
      //     this.isScanning = false;
      //     this.dataIdEscaneo = _response.data_id;

      //     // this.verificarProgreso().subscribe({
      //     //   next: (resp) => console.log("Progreso:", resp.sanitized.progress_percentage),
      //     //   complete: () => console.log("Proceso completado"),
      //     //   error: (err) => console.error("Error:", err)
      //     // });
      //   },(error: {}) => {
      //     console.error(error);
      //     console.error('Error al escanear el archivo:', error);
      //     alert('Hubo un error al escanear el archivo.');
      //     this.isScanning = false;
      //   }
      // );
    }
  }

  // Función para convertir el archivo a base64
  convertirBase64(file: File): void {
    const reader = new FileReader();
    reader.onloadend = () => {
      this.fileBase64 = reader.result as string;
    };
    reader.readAsDataURL(file);
  }

  // Función para obtener la extensión del archivo
  getExtensionArchivo(fileName: string): string {
    return fileName.split('.').pop()?.toLowerCase() || ''; // Extrae la extensión
  }

  // Validación personalizada para el archivo (solo PDF y Word)
  validacionArchivos(control: AbstractControl) {
    console.log(control);

    const file: any = control.value;
    if (!file) {
      return null; // Si no hay archivo, o no es un archivo, no hay error
    }

    const allowedExtensions = ['pdf', 'doc', 'docx'];
    const fileExtension = file.split('.').pop()?.toLowerCase();

    if (allowedExtensions.indexOf(fileExtension || '') === -1) {
      return { archivoInvalido: true }; // Si el archivo no tiene una extensión válida
    }

    // // Validar el tamaño (por ejemplo, 5MB máximo)
    // const maxSize = 5 * 1024 * 1024; // 5 MB en bytes
    // if (file.size > maxSize) {
    //   return { invalidFileSize: true }; // Si el archivo es demasiado grande
    // }

    return null; // Si la extensión es válida
  }

  // Método para subir y escanear el archivo
  scanFile() {
    if (!this.selectedFile) {
      alert('Selecciona un archivo primero.');
      return;
    }

    this.isScanning = true;
    this.escaneoApiService.postEscanearAntivirus(this.selectedFile).subscribe(
      (data: []) => {
        console.log(data);
        this.scanResult = data;
        this.isScanning = false;
      }, (error: {}) => {
        console.error(error);
        console.error('Error al escanear el archivo:', error);
        alert('Hubo un error al escanear el archivo.');
        this.isScanning = false;
      }
    );
  }





  mensajeCodigoActivacion = '';
  recibirMensajeCodigoActivacion(mensaje: string) {
    this.mensajeCodigoActivacion = mensaje;
  }

  codigoActivacion = '';
  recibirCodigoActivacion(codigo: string) {
    this.codigoActivacion = codigo;
  }

  onOpenFileCV(event: any, file: string) {
    window.open(environment.urlStorage + 'ass.pdf', '_blank');
  }

  onDeleteFileCV() {
    this.cvNombre = '';
  }

  /**
   * Registra un candidato en Appian usando el nuevo servicio make_candidate
   */
  registrarCandidato(): Observable<any> {
    // Validar campos obligatorios antes de enviar
    if (!this.registroForm.valid) {
      this.registroForm.markAllAsTouched();
      return throwError(() => new Error('El formulario contiene errores. Por favor, revisa los campos marcados.'));
    }

    // Obtener valores del formulario
    const phoneNumber = (this.registroForm.value.celular || '').toString().replace(/\s+/g, '').replace(/\D/g, '');
    
    // Formatear fecha de nacimiento (YYYY-MM-DD)
    const fechaNacimientoFormatted = this.fechaNacimiento || '';
    
    // Obtener sueldo de interés (pretensiones)
    const sueldoInteres = parseFloat(this.pretensiones) || 0;

    // Preparar el body del request según la especificación
    const requestBody = {
      nombre: this.nombre || '',
      apellido1: this.primerApellido || '',
      apellido2: this.segundoApellido || '',
      email: this.email || '',
      phoneNumber: phoneNumber,
      fechaNacimiento: fechaNacimientoFormatted,
      sueldoInteres: sueldoInteres,
      giroEmpleo: this.giroEmpleo || '',
      experiencia: this.experiencia || 0,
      origen: 'texto', // Valor por defecto
      campanna: 'texto', // Valor por defecto
      positionId: this.positionId || (this.vacante?.requisicion ? Number(this.vacante.requisicion) : 0),
      genero: 1 // Valor por defecto
    };

    // Configurar headers con la API key de Appian (mismo estándar que otros servicios)
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'appian-api-key': environment.appianApiKey,
      'Accept': 'application/json'
    });

    // URL del endpoint - usar URL completa si no hay proxy, sino usar proxy
    const url = environment.useProxy 
      ? `${environment.urlAppian}/make_candidate`
      : (environment.urlAppianMakeCandidate || `${environment.urlAppian}/make_candidate`);

    console.log('🚀 Enviando registro a Appian:', {
      url,
      body: { ...requestBody, phoneNumber: phoneNumber.substring(0, 4) + '****' }, // Ocultar número completo en logs
      apiKey: (environment.appianApiKey || '').substring(0, 20) + '...'
    });

    // Realizar la petición POST - manejar respuesta como texto para evitar errores de parsing
    return this.http.post(url, requestBody, { headers, responseType: 'text' }).pipe(
      map((res: string) => {
        console.log('📥 Respuesta completa de make_candidate (texto):', res);
        
        if (!res || res.trim() === '') {
          console.warn('⚠️ Respuesta vacía');
          return { success: false, message: 'Respuesta vacía del servidor' };
        }

        // Intentar parsear como JSON
        try {
          const parsed = JSON.parse(res);
          console.log('✅ Respuesta parseada como JSON:', parsed);
          return parsed;
        } catch (e) {
          console.warn('⚠️ No es JSON válido, procesando como texto...');
          console.log('📄 Contenido del texto:', res.substring(0, 500));
          
          // Intentar extraer JSON del texto si está embebido
          const jsonMatch = res.match(/\{[\s\S]*\}/);
          if (jsonMatch) {
            try {
              const parsed = JSON.parse(jsonMatch[0]);
              console.log('✅ JSON extraído y parseado del texto:', parsed);
              return parsed;
            } catch (e2) {
              console.warn('⚠️ No se pudo parsear el JSON extraído');
            }
          }
          
          // Si la respuesta es un mensaje de éxito simple, retornar éxito
          if (res.toLowerCase().includes('éxito') || 
              res.toLowerCase().includes('exito') || 
              res.toLowerCase().includes('success') ||
              res.toLowerCase().includes('candidato creado') ||
              res.toLowerCase().includes('candidato registrado')) {
            console.log('✅ Mensaje de éxito detectado en texto');
            return { success: true, message: res };
          }
          
          // Si la respuesta es un mensaje de error, retornar error
          if (res.toLowerCase().includes('error') || 
              res.toLowerCase().includes('fallo') ||
              res.toLowerCase().includes('failed')) {
            console.warn('⚠️ Mensaje de error detectado en texto');
            return { success: false, message: res };
          }
          
          // Por defecto, asumir éxito si hay contenido
          return { success: true, message: res, raw: res };
        }
      }),
      tap((response) => {
        console.log('✅ Registro exitoso en Appian:', response);
      }),
      catchError((error) => {
        console.error('❌ Error al registrar candidato en Appian:', error);
        console.error('❌ Detalles del error:', {
          status: error.status,
          statusText: error.statusText,
          message: error.message,
          error: error.error
        });
        
        // Si el error es de parsing (status 200 pero ok: false), intentar extraer información
        if (error.status === 200 && error.error) {
          try {
            const errorText = typeof error.error === 'string' ? error.error : JSON.stringify(error.error);
            console.log('📄 Error como texto:', errorText);
            
            // Intentar parsear el error
            const jsonMatch = errorText.match(/\{[\s\S]*\}/);
            if (jsonMatch) {
              try {
                const parsed = JSON.parse(jsonMatch[0]);
                return throwError(() => ({ ...parsed, status: 200 }));
              } catch (e) {
                // Si no se puede parsear, retornar el texto
                return throwError(() => ({ 
                  success: false, 
                  message: errorText,
                  status: 200 
                }));
              }
            }
          } catch (e) {
            // Ignorar errores de procesamiento
          }
        }
        
        return throwError(() => error);
      })
    );
  }

}

